<template>
    <section class="faq-section" id="faq">
        <div class="question-shevrone">
            <img src="../assets/icons/question-shevrone.svg" alt="">
        </div>
        <div class="container">
            <div class="row center-lg align-left">
                <div class="col-xs-12 col-gi-10">
                    <h3 class="section-title faq-title margin-bottom bordered-heading headline_h2">FAQ – <br>Häufig gestellte Fragen</h3>
                    <div class="faq-container">
                        <div class="faq-card" v-for="(faq, index) in faqList" :key="index">
                            <div class="faq-title text" :class="{active: selectedIndex === index}" @click="toggle(index)">{{ faq.title }}</div>
                            <CollapseTransition dimension="height">
                                <div class="faq-content text" v-show="selectedIndex === index" v-html="faq.description"></div>
                            </CollapseTransition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
export default {
    name: "FAQ",
    components: {
        CollapseTransition
    },
    data: () => ({
        selectedIndex: null,
        faqList: [
            {
                title: 'Kommen Kosten oder Gebühren auf mich zu? ',
                description: 'Nein. Der Verkauf ist für dich zu 100 % kostenlos - auch wenn du den Angebotspreis des Händlers nicht annimmst.'
            },
            {
                title: 'Wie funktioniert der Verkauf?',
                description: `Als Erstes erhältst du eine kostenlose und unverbindliche Preisbewertung deines Fahrzeugs und vereinbarst deinen Wunschtermin bei einer Ankaufstation in deiner Nähe. Am besten bringst du zum Termin noch Folgendes mit:
                <ul class="styled-list">
                    <li>Fahrzeugschein (Zulassungsbescheinigung Teil 1)</li>
                    <li>Fahrzeugbrief (Zulassungsbescheinigung Teil 2)</li>
                    <li>alle Fahrzeugschlüssel</li>
                    <li>gültigen Personalausweis oder Reisepass</li>
                    <li>Serviceheft (falls vorhanden)</li>
                    <li>Bescheinigungen der letzten Haupt- und Abgasuntersuchung (falls vorhanden)</li>
                    <li>Werkstattrechnungen (falls vorhanden)</li>
                </ul>
                Nach einer kurzen Besichtigung deines Fahrzeugs macht dir der Händler ein für dich unverbindliches Angebot. Die vorherige Preisbewertung kann von dem Angebotspreis abweichen, da wertbeeinflussende Faktoren wie Zustand, Ausstattung oder Schäden den Angebotspreis beeinflussen können. <br/>Bist du mit dem Preis einverstanden, erhältst du das Geld in bar oder per Sofort-Überweisung auf dein Konto. Gerne hilft dir der Händler bei der Abmeldung und Kündigung der Versicherung bzw. Ummeldung des Fahrzeugs im Falle einer Inzahlungnahme.`
            },
            {
                title: 'Wie wird der Preis ermittelt?',
                description: 'Der Preis wird transparent, fair und aktuell durch unsere TÜV Rheinland verifizierte Marktwertanalyse ermittelt. Dabei werden wertbeeinflussende Faktoren wie z. B. Ausstattung, Alter und Laufleistung berücksichtigt. Die Preisbewertung erfolgt unabhängig vom Fahrzeugzustand. Das Angebot des Händlers kann davon abweichen.'
            },
            {
                title: 'Was muss ich zum Termin mitbringen?',
                description: `Bringe zu deinem Termin Folgendes mit:
                <ul class="styled-list">
                    <li>Fahrzeugschein (Zulassungsbescheinigung Teil 1)</li>
                    <li>Fahrzeugbrief (Zulassungsbescheinigung Teil 2)</li>
                    <li>alle Fahrzeugschlüssel</li>
                    <li>gültigen Personalausweis oder Reisepass</li>
                    <li>Serviceheft (falls vorhanden)</li>
                    <li>Bescheinigungen der letzten Haupt- und Abgasuntersuchung (falls vorhanden)</li>
                    <li>Werkstattrechnungen (falls vorhanden)</li>
                    <li>Was hin und wieder vergessen wird: Zweitradsatz, Laderaumabdeckung, Fußmatten.</li>
                </ul>
                `
            },
            {
                title: 'Muss ich mein Auto zum Angebotspreis verkaufen?',
                description: 'Nein, wenn der Angebotspreis nicht deinen Vorstellungen entspricht, musst du auch nicht verkaufen. Solltest du es dir später anders überlegen, kannst du ganz einfach einen neuen Termin vereinbaren.'
            },
            {
                title: 'Wie lange dauert der Termin vor Ort?',
                description: 'In der Regel dauert die Besichtigung deines Fahrzeugs 30 Minuten.'
            },
        ]
    }),
    methods: {
        toggle(index) {
            if(this.selectedIndex === index) {
                this.selectedIndex = null;
            } else {
                this.selectedIndex = index;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";

    .faq-section {
        position: relative;
        border-top: 3px solid #C0141B;
        padding:40px 0 20px;
        background: #f2f2f2;

        @include breakpoint(frommediumlarge) {
            padding:50px 0;
        }

        @include breakpoint(fromgiant) {
            padding:100px 0;
        }

        .question-shevrone {
            position: absolute;
            top: 0;
            left: 18px;

            @include breakpoint(fromgiant) {
                left: 10vw;
            }
            @media (min-width: 2150) {
                left: calc(50vw - (1300px / 2));
            }
        }

        h3.faq-title {
            br {
                @include breakpoint(frommediumlarge) {
                    display:none;
                }
            }
        }
    }
    .faq-container {
        padding-top:17px;

        @include breakpoint(frommediumlarge) {
            padding-top:0;
        }

        @include breakpoint(fromgiant) {
            padding-top:17px;
        }
        &.responsive {
            @media screen and (min-width:650px) {
                display: grid;
                gap: 0 18px;
                grid-template-columns: 1fr 1fr;
            }
        }
    }

    .section-title {
        margin-top: 40px;

        @include breakpoint(fromgiant) {
            margin-top: initial;
        }
    }
    .faq-card {
        margin-bottom: 25px;
        display:block;

        .question {
            display:flex;
            align-items: center;
            justify-content: flex-start;

            .prefix-icon {
                margin-right:13px;
                padding-top:4px;
                .icon {
                    font-size:32px;
                }

                &.small-icon {
                    .icon {
                        font-family: 'Glyphter', sans-serif;
                        color:rgba(#444,.5);
                        font-size:20px;
                    }
                }
            }
        }
        .faq-title {
            background-color: $white;
            border:1px solid $border-color;
            border-radius: 4px;
            cursor: pointer;
            padding: 20px;
            padding-right: 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color:$black-variant;
            position:relative;
            transition:300ms background-color ease-in-out, 300ms color ease-in-out, 300ms border ease-in-out;


            &:after {
                font-family: "Material Icons";
                content: "\e145";
                position:absolute;
                display:block;
                top:18px;
                right:19px;
                color:#DADADA;
                font-size:24px;
                transition:300ms color ease-in-out;
            }

            .question {
                width:calc(100% - 30px)
            }

            &:hover,
            &:focus,
            &:active,
            &.active {
                background-color: $red;
                border:1px solid $red;
                color: #fff;

                &:before {
                    color:$white;
                }
            }
        }
        .faq-content {
            display:block;
            padding: 24px 0 4px;
            padding-left:0 !important;
            padding-right: 0 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/local-components/FAQ.vue